import styled, { css } from 'styled-components';
import type {Theme as ThemeType} from '@/styles/Themes'

const selectVariants = (theme:ThemeType, variant = 'primary') =>
	({
		primary: css`
			border: 1.5px solid ${theme.background.primary};
			color: ${theme.background.primary};
		`,
		secondary: css`
			border: 1.5px solid ${theme.background.secondary};
			color: ${theme.background.secondary};
		`,
		danger: css`
			border: 1.5px solid ${theme.background.danger};
			color: ${theme.background.danger};
		`,
	}[variant]);

export const Button = styled.button<{ variant?: string }>`
	border: 1px solid #e8e8e8;
	min-height: calc(2.5em - 0.3rem);
	padding: 0.25rem 0.5rem;
	font-size: 16px;
	color: #333;
	outline: none;
	cursor: pointer;
	background-color: transparent;
	color: white;

	${({ theme, variant }) => selectVariants(theme, variant)}

	&:disabled {
		background-color: #e8e8e8;
		cursor: not-allowed;
	}

	&:focus {
		outline: 1px solid;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const SwitchLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
`;

export const Switch = styled.div`
	position: relative;
	width: 60px;
	height: 28px;
	background: #b3b3b3;
	transition: 300ms all;
	border-radius: 32px;
	padding: 1rem;

	&:before {
		content: '';
		transition: 300ms all;
		position: absolute;
		width: 24px;
		height: 24px;
		border-radius: 35px;
		top: 50%;
		left: 4px;
		background: white;
		transform: translate(0, -50%);
	}
`;

export const SwitchInput = styled.input`
	opacity: 0;
	position: absolute;

	&:checked + ${Switch} {
		background: ${({ theme }) => theme.background.primary};

		&:before {
			transform: translate(28px, -50%);
		}
	}
`;
